export const customerAddressFields = [{
        name: "description",
        title: "Descrizione",
        render: (record) => record.description
    }, {
        name: "street",
        title: "Indirizzo",
        render: (record) => record.street
    }, {
        name: "civicNumber",
        title: "Num. Civico",
        render: (record) => record.civicNumber
    }, {
        name: "city",
        title: "Città",
        render: (record) => record.city
    }, {
        name: "province",
        title: "Provincia",
        render: (record) => record.province
    }, {
        name: "zipCode",
        title: "CAP",
        render: (record) => record.zipCode
    }, {
        name: "country",
        title: "Nazione",
        render: (record) => record.country
    }, {
        name: "headquarters",
        title: "Principale",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.headquarters === 1 ? "check" : ""}</i>`
    }];
